import BaseApi from "./BaseApi";

export default class PrecificacaoService {

    static getEstados(cursoId) {
        return BaseApi.get(`/precificacao/v1/GetEstados/${cursoId}`);
    }

    static getLocais(estadoId, cidadeId) {
        return BaseApi.get(`/precificacao/v1/GetLocais/${estadoId}/${cidadeId}`);
    }

    static getCursosListFicha(nivelId, modalidadeId) {
        return BaseApi.get(`/precificacao/v1/GetCursosListFicha/${nivelId}/${modalidadeId}`);
    }

    static getPrecoCurso(cursoId, localId, turnoid, opcaoIngressoId) {
        return BaseApi.get(`/precificacao/v1/GetPrecoCurso/${cursoId}/${localId}/${turnoid}/${opcaoIngressoId}`);
    }

    static getModalidades(nivelId) {
        return BaseApi.get(`/precificacao/v1/getModalidades/${nivelId}`);
    }

    static getLocaisCurso(cursoId, cidadeId) {
        return BaseApi.get(`/precificacao/v1/GetLocaisCurso/${cursoId}/${cidadeId}`);
    }

    static getTurnosByCursoAndLocal(cdCurso, cdLocal) {
        return BaseApi.get(`/precificacao/v1/GetTurnos/${cdCurso}/${cdLocal}`);
    }
}